export const DOCS_DISPLAY_TYPE = {
  SIDEBAR: "SIDEBAR",
  TOOLTIP: "TOOLTIP",
} as const;
